import { ComponentPropsWithoutRef } from 'react';

const ExternalIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg width="16px" height="15px" viewBox="0 0 16 15" {...props}>
    <path
      d="M45.561 499.079h8.89v8.89m0-8.89L41.53 512"
      transform="translate(-560 -682) translate(520 184)"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    />
  </svg>
);

export default ExternalIcon;
